export default {
  header: {
    review_us: 'Anmeld os på Google',
    upload: 'Upload Google-anmeldelse',
    not_now: 'Ikke nu',
  },
  steps: {
    how_it_works: 'Sådan fungerer det',
    step_1: {
      title: 'Trin',
      description: 'Skriv en anmeldelse af {{name}} på Google',
    },
    step_2: {
      title: 'Trin',
      description: 'Upload et skærmbillede af din opslåede anmeldelse (se eksemplet nedenfor)',
    },
  },
  buttons: {
    upload_screenshot: 'Upload skærmbillede',
    leave_google_review: 'Skriv Google-anmeldelse',
    submit_screenshot: 'Send skærmbillede',
    return: 'Tilbage',
  },
  enter_name: {
    title: 'Navn brugt i din Google-anmeldelse',
    place_holder: 'Indtast navn',
  },
  screenshot_uploaded: {
    title: 'Skærmbillede uploadet',
    description: 'Scroll ned for at se hele skærmbilledet',
  },
  loading: {
    processing: 'Din opslåede anmeldelse bliver gennemgået',
  },
  error_messages: {
    upload_failed: 'Skærmbilledet kunne ikke uploades. Prøv igen.',
    review_already_uploaded:
      'Det ser ud til, at du allerede har uploadet et skærmbillede af en Google-anmeldelse. Du kan kun få belønning én gang for en Google-anmeldelse 😊',
    name_missing: {
      description: 'Indtast det navn, der blev brugt i din Google-anmeldelse, så vi kan finde dine oplysninger.',
      button: {
        title: 'Okay',
      },
    },
  },
};
